import { PhysicalIdURI } from "@cur8/uri";
import { APITypesV1 } from "@cur8/api-client";
import { DateTime } from "luxon";

export type ContactDetails = {
  addressLines: string[];
  countryOrRegion: string;
  zipCode: string;
  phoneNumbers: string[];
  email: string;
};

export type PersonName = {
  firstName?: string;
  lastName?: string;
  displayName?: string;
};

export type ConsentData = {
  expiresAt?: DateTime;
  createdAt?: DateTime;
};

export enum Sex {
  Unknown,
  Male,
  Female,
}

export enum UnitSystem {
  Imperial = "imperial",
  Metric = "metric",
}

export type Patient = {
  patientId: string;
  physicalIds: (PhysicalIdURI | string)[];
  name?: PersonName;
  contactDetails: ContactDetails;
  dateOfBirth?: DateTime;
  consent: ConsentData;
  preferredLanguage?: string;
  preferredCountry: string;
  sex: Sex;
  allergies: string[];
  ethnicities: string[];
  groupIds: string[];
  primaryConsentRuleset: APITypesV1.ConsentRuleset | undefined;
  flags: APITypesV1.PatientFlag[];
  hasPasskey: boolean;
  hasVerifiedIdentity: boolean;
  preferredUnitSystem: UnitSystem;
};
